
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CelebrationIcon from '@mui/icons-material/Celebration';
import TtkList from './TtkList';
const OnRentTTK = ({ data }) => {
    return (
        <>
       <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area Of Working :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p ><AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Covered Of Event :</b>&nbsp;<span>{data?.coveredOfEvent}</span></p>
                        </div>
                       
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered :</b>&nbsp;<TtkList data={data?.serviceOfferedOnRent} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
      )
}

export default OnRentTTK